import { createSelector } from '@ngrx/store';
import { geolocationState } from '../root';

export const getGeolocationCoords = createSelector(geolocationState, (geolocation) => geolocation?.data);
